import { render } from "./ArticleListItem.vue?vue&type=template&id=b2c11640&scoped=true"
import script from "./ArticleListItem.vue?vue&type=script&lang=js"
export * from "./ArticleListItem.vue?vue&type=script&lang=js"

import "./ArticleListItem.vue?vue&type=style&index=0&id=b2c11640&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b2c11640"

export default script